const SuccessMessage = ({message}) => {
  return (
    <div className="text-success">{message}</div>
  )
}

export default SuccessMessage
